/**
 * 주어진 HTML 문자열이 유효한지 확인
 *
 * @param {string} htmlString - 확인할 HTML 문자열
 * @returns {boolean} - HTML 문자열이 유효하면 `true`, 그렇지 않으면 `false`
 */
export const useIsValidHTML = (htmlString: string): boolean =>
  htmlString.includes('<') && htmlString.includes('>')
